DialogController = App.loadClass 'core::Angular/DialogController'

class exports.AddPicController extends DialogController
    constructor: (@scope, @transitions, @data, @modalInstance) ->
        super(@scope, @transitions, @modalInstance)

        @scope.title = 'Add Pic'
        @scope.caption = ''
        @scope.file = null
        @scope.parseInt = @parseInt

    parseInt: (val) =>
        parseInt val

    save: () =>
        @data.addPic(@scope.caption, @scope.file).then (response) =>
            @closeWithAlert(response.data.status)
